export enum PreferredInterestPaymentType {
    CurrentPayReserve = 0,
    Accrual = 1,
}
